'use strict';

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.find/~/es-to-primitive/helpers/isPrimitive.js
// module id = 2701
// module chunks = 0